import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { BranchTypes } from 'src/app/shared/enums/branch-types.enum'
import { BranchInformationModel } from '../../models/branch-information.model'
import { Subscription } from 'rxjs'
import { OrganizationsService } from '../../services/organizations.service'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { MatDialog } from '@angular/material/dialog'
import { ToastrService } from 'ngx-toastr'
import { TranslateService } from '@ngx-translate/core'

@Component({
	selector: 'app-organization-branch-target-audience',
	templateUrl: './organization-branch-target-audience.component.html',
	styleUrls: ['./organization-branch-target-audience.component.scss'],
})
export class OrganizationBranchTargetAudienceComponent
	implements OnInit, OnDestroy
{
	@Input() branchInformationData!: BranchInformationModel
	subscription = new Subscription()
	BranchTypes = BranchTypes
	editMode = false
	types: any = []
	changed: boolean = false
	constructor(
		private organizationsService: OrganizationsService,
		private dialog: MatDialog,
		private toaster: ToastrService,
		private translate: TranslateService
	) {}
	savedTragetAudience: [] = []
	ngOnInit(): void {}

	ngOnChanges() {
		this.types = this.branchInformationData?.targetAudience?.length
			? this.branchInformationData?.targetAudience.map(
					(val) => val?.targetAudience
			  )
			: []
	}

	branchChanged(event: any) {
		const indx = this.types.findIndex((val: any) => val == event.source.value)
		if (event.checked) this.types.push(event.source.value)
		else {
			const checkIfFound = this.branchInformationData?.targetAudience.find(
				(val) => val.targetAudience == event.source.value
			)
			if (checkIfFound) {
				this.dialog
					.open(ConfirmationMessageComponent, {
						width: '416',
						height: '360',

						data: {
							image: 'assets/images/block.svg',
							notflex: true,

							message: 'CONFIRMATION_MESSAGE.DELETE_TARGET_AUDIENCE',

							cancelBtn: 'ACTIONS.CANCEL',
							confirmBtn: 'ACTIONS.DELETE',
						},
					})
					.afterClosed()
					.subscribe({
						next: (res) => {
							if (res) {
								this.types.splice(indx, 1)
							} else {
								event.source.toggle()
							}
						},
					})
			} else this.types.splice(indx, 1)
		}
	}

	changeEditMode(cancel?: boolean) {
		this.editMode = !this.editMode
		cancel
			? (this.types = this.branchInformationData?.targetAudience.map(
					(val) => val?.targetAudience
			  ))
			: null
	}

	saveChanges(): void {
		const requestBody = {
			id: this.branchInformationData?.id,
			targetAudiences: this.types,
		}
		this.subscription.add(
			this.organizationsService.updateTargetAudience(requestBody).subscribe({
				next: () => {
					this.changeEditMode()
					let oldTarget = this.types.map((val: number) => {
						let item = this.branchInformationData.targetAudience.find(
							(obj) => obj.targetAudience == val
						)
						if (!item) return { targetAudience: val, canDelete: true }
						else return item
					})
					this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
					this.branchInformationData.targetAudience = [...oldTarget]
				},
				error: (err) => {},
			})
		)
	}

	checkIfDisabled(branchType: any) {
		const val = this.branchInformationData?.targetAudience?.find(
			(target) => target?.targetAudience == branchType
		)
		return val ? !val?.canDelete : false
	}

	checkDisable() {
		return (
			!this.types?.length ||
			JSON.stringify(this.types) ==
				JSON.stringify(
					this.branchInformationData?.targetAudience.map(
						(val) => val?.targetAudience
					)
				)
		)
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
